'use client'

// Side-effect import: runs storyblokInit() to register apiPlugin + components on the client
import '@/lib/storyblok'

import { getStoryblokApi } from '@/lib/storyblok-api'

export default function StoryblokProvider({ children }: { children: React.ReactNode }) {
  getStoryblokApi() // Re-initialize on the client

  return children
}
